// extracted by mini-css-extract-plugin
export default {"declineButton":"ResetEffectsModal_declineButton__vCHJn"};